








import { Component } from 'vue-property-decorator';
import AuthComponent from '@share/auth/AuthComponent.vue';
import { AuthRepository } from "@api/repositories/AuthRepository";
import ExternalAuth from "@share/auth/ExternalAuth.vue";
import {FreshChat} from "@common/FreshChat";
import GetParamsAuth from "@share/auth/GetParamsAuth.vue";
import {hasSessionParams} from "@share/auth/QueryHasSessionParamsHelper";
import LoginLogic from '@share/auth/LoginLogic.vue';

@Component({
    components: {GetParamsAuth, AuthComponent, ExternalAuth }
})
export default class Login extends LoginLogic {
    authRepository: AuthRepository = this.$repositories.get('auth');

    showVueAuthForm = false;
    freshChat: FreshChat | null = null

    get freshChatToken() {
        return this.$store.getters['services/freshChatToken'];
    }

    get hasLoginGetParams() {
        return hasSessionParams(this.$route);
    }

    externalFormNotFound() {
        this.showVueAuthForm = true;
    }

    configLoaded() {
        if  (this.freshChatToken) {
            this.$store.dispatch('services/initFreshChat')
        }
    }
}
